import PropTypes from "prop-types";
import React from "react";
import {
    Button,
    Dimmer,
    Grid,
    Loader,
    Message,
    Segment,
} from "semantic-ui-react";
import ContextEditor from "./ContextEditor";
import SubmissionPane from "./SubmissionPane";
import DescriptionParser from "./util/DescriptionParser";
import Markdown from "./util/Markdown";

class ContextBody extends React.PureComponent {

    constructor() {
        super();
        this.state = {
            mode: "view",
        };
    }

    render() {
        const {
            isDm,
            context: c,
            updateContext,
            createSubmission,
        } = this.props;
        const {
            mode,
        } = this.state;
        const viewContent = content =>
            <Segment>
                {mode === "saving" && <Dimmer active>
                    <Loader content="Saving" />
                </Dimmer>}
                <Grid columns={2} stackable divided>
                    <Grid.Column width={11}>
                        {content}
                    </Grid.Column>
                    <Grid.Column width={5}>
                        {c.regions && <SubmissionPane context={c}
                                                      createSubmission={createSubmission}
                        />}
                    </Grid.Column>
                </Grid>
            </Segment>;
        if (isDm) {
            if (mode === "edit") {
                return <Segment>
                    <ContextEditor context={c}
                                   doCancel={() => this.setState({ mode: "view" })}
                                   doSave={fields => {
                                       this.setState({ mode: "saving" });
                                       updateContext(fields)
                                           .then(() =>
                                               this.setState({ mode: "view" }),
                                           );
                                   }}
                    />
                </Segment>;
            } else {
                const stripped = new DescriptionParser(c.description).stripped;
                return viewContent(<div>
                    {c.parsedDescription && c.parsedDescription !== stripped && <Message warning>
                        <Message.Header>
                            Out of Sync!
                        </Message.Header>
                        <Grid columns={2} stackable={false} divided>
                            <Grid.Column width={8}>
                                <pre style={{overflowX: "scroll"}}>{c.parsedDescription}</pre>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <pre style={{overflowX: "scroll"}}>{stripped}</pre>
                            </Grid.Column>
                        </Grid>
                        <p>
                            You can get back in sync by saving, but
                            if it's because of software versions, be
                            careful!
                        </p>
                    </Message>}
                    <Button icon="pencil"
                            content="Edit"
                            floated="right"
                            onClick={() => this.setState({ mode: "edit" })}
                    />
                    <Markdown text={stripped || ""} />
                </div>);
            }
        } else {
            return viewContent(<Markdown
                text={c.parsedDescription || new DescriptionParser(c.description).stripped || ""}
            />);
        }
    }

}

ContextBody.propTypes = {
    isDm: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    updateContext: PropTypes.func.isRequired,
    createSubmission: PropTypes.func.isRequired,
};

export default ContextBody;



// WEBPACK FOOTER //
// ./src/ContextBody.js